import { EditorContent, useEditor } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import Placeholder from "@tiptap/extension-placeholder";
import Link from "@tiptap/extension-link";
import Underline from "@tiptap/extension-underline";
import Highlight from "@tiptap/extension-highlight";
import { makeStyles } from "@mui/styles";
import { useEffect } from "react";
import { isEmpty } from "lodash";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(0.1),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    border: `1px solid ${theme.palette.grey[400]}`,
    borderRadius: 4,
    "&:focus": {
      outline: "none",
      border: `1px solid ${theme.palette.primary.main}`,
    },
    "&:hover": {
      borderColor: theme.palette.grey[900],
    },
    "& p.is-editor-empty:first-child::before": {
      color: theme.palette.grey[700],
      content: "attr(data-placeholder)",
      float: "left",
      height: 0,
      pointerEvents: "none",
    },
  },
  error: {
    borderColor: theme.palette.error.main,
    "& p.is-editor-empty:first-child::before": {
      color: theme.palette.error.main,
    },
  },
}));

export default function TipTapEditor({
  valueHtml,
  placeholder,
  onChange,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  error = false,
}: {
  valueHtml: string;
  placeholder?: string;
  onChange: (newValueHtml: string) => void;
  error?: boolean;
}) {
  const classes = useStyles();

  // this doesn't update when you change the props so abandon validation for now
  // const editorClass = clsx(classes.root, {
  //   [classes.error]: error,
  // });
  const editorClass = classes.root;

  const editor = useEditor({
    editorProps: {
      attributes: {
        class: editorClass,
      },
    },
    onUpdate: ({ editor }) => {
      const html = editor.getHTML();
      onChange(html);
    },
    // onBlur: ({ editor }) => {
    //   // TODO trigger this event and maybe other useful events from
    //   // https://tiptap.dev/api/events
    // },
    extensions: [
      // TextStyle.configure({ types: [ListItem.name] }),
      StarterKit.configure({
        bulletList: {
          keepMarks: true,
          keepAttributes: false, // TODO : Making this as `false` becase marks are not preserved when I try to preserve attrs, awaiting a bit of help
        },
        orderedList: {
          keepMarks: true,
          keepAttributes: false, // TODO : Making this as `false` becase marks are not preserved when I try to preserve attrs, awaiting a bit of help
        },
      }),
      Placeholder.configure({
        placeholder,
      }),
      Link.configure({
        protocols: ["http", "https", "mailto"],
        autolink: true,
      }),
      Underline.configure({}),
      Highlight.configure({
        multicolor: true,
      }),
    ],
    content: valueHtml,
  });

  // this doesn't work - when you type a space character it deletes itself.
  // maybe we need to do something with `useEditor` here to make it fully
  // React-compatible and allow parents to supply props?
  // useEffect(() => {
  //   if (editor && !isEmpty(valueHtml)) {
  //     console.log("setting content", { valueHtml });
  //     editor.commands.setContent(valueHtml);
  //   }
  // }, [editor, valueHtml]);

  useEffect(() => {
    if (editor && isEmpty(valueHtml)) {
      console.log("clearing content");
      editor.commands.clearContent();
    }
  }, [editor, valueHtml]);

  return (
    <div>
      {/* <TipTapMenu editor={editor} /> */}
      {editor ? <EditorContent content={valueHtml} editor={editor} /> : null}
    </div>
  );
}
